import React from 'react';
import { Result } from 'antd';
import { Link } from '@nackle/biw-web-router';

export default class ErrorBoundary extends React.Component {
    constructor( props ) {
      super( props );
      this.state = { hasError: false };
    }

    static getDerivedStateFromError( error ) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }


    render() {
      const { isUmbrella, companyId } = this.props;
      if ( this.state.hasError ) {
        return (
            <Result
                status="500"
                title="Application Error"
                extra={ <Link to={ `/${ isUmbrella ? '/privacy' : `/${ companyId }` }` } className="ant-btn ant-btn-primary">Back Home</Link> }
            />
        );
      }

      return this.props.children;
    }
  }
